import wretch from 'wretch';

import { IAuthTokenRequest, IFormResponse } from './models';

export async function apiPostAuthToken({
  token,
}: IAuthTokenRequest): Promise<void> {
  await wretch('/api/1/authorization/by-token').post({ token }).res();
}

export async function apiPostWireForm({
  token,
  model,
}): Promise<IFormResponse> {
  return wretch('/api/1/withdrawals/request')
    .auth(`Bearer ${token}`)
    .post(model)
    .json();
}
